/** La carte des sorties et la maquette d'un campus. */
export const carte = {
  ecran: {
    voirTout: 'Voir tout',
    dansLaZone: 'Dans la zone',
    impossible: 'Impossible pour le moment.',
    recherchePosition: 'Recherche de ta position…',
    activerLocalisation: 'Active ta localisation pour te voir sur la carte',
    unSansAdresse: 'Un événement sans adresse précise n’y figure pas.',
    revenir: 'Revenir sur ma position',
    personneInscrit: 'Personne encore inscrit',
    inscrit: 'Tu es inscrit(e)',
    demandeEnvoyee: 'Demande envoyée',
    listeAttente: 'Rejoindre la liste d’attente',
    rejoindre: 'Rejoindre cet événement',
    plusTard: 'Peut-être plus tard',
    aucun: 'Aucun événement',
    un: '1 événement',
    videCarte: 'Aucun événement n’est encore posé sur la carte. Les prochains s’y ajouteront tout seuls.',
    videZone: 'Rien dans cette partie de la carte. Éloigne-toi ou déplace-la pour en voir d’autres.',
    sansAdresse: (n: number) => `${n} événements sans adresse précise n’y figurent pas.`,
    participants: (n: number) => (n === 1 ? '1 participant' : `${n} participants`),
    memeEndroit: (n: number) => `${n} événements au même endroit`,
    plusieurs: (n: number) => `${n} événements`,
  },
  apple: {
    pasOuverte: 'La carte Apple n’a pas pu s’ouvrir.',
    pasChargee: 'La carte Apple n’a pas pu se charger.',
  },
  libre: {
    pasAffichee: 'La carte n’a pas pu s’afficher sur cet appareil.',
    pasChargee: 'La carte n’a pas pu se charger. Vérifie ta connexion.',
  },
  placer: {
    titre: 'Placer sur le campus',
    deplacer: 'Déplace le repère du doigt pour l’ajuster.',
    toucher: 'Touche le plan à l’endroit de l’événement.',
    placerIci: 'Placer ici',
  },
  pastilles: {
    maPosition: 'Ma position',
    sortie: (titre: string, categorie: string, spontanee: boolean) =>
    `${titre}, ${categorie.toLowerCase()}${spontanee ? ', spontanée' : ''}`,
    groupe: (n: number) => `${n} sorties a cet endroit`,
  },
  maquette: {
    pasAffichee: 'La maquette n’a pas pu s’afficher sur cet appareil.',
  },
  placerMaquette: {
    pasAffichee: 'La maquette ne s’affiche pas sur cet appareil.',
    deplacer: 'Touche ailleurs pour le déplacer.',
    toucher: 'Touche la maquette à l’endroit de l’événement.',
  },
  apercu: {
    credits: '© OpenStreetMap · OpenFreeMap',
    carteDuLieu: (lieu: string) => `Carte du lieu : ${lieu}`,
  },
};
